// Replace a node's contents with HTML parsed via DOMParser. Used in
// place of `node.innerHTML = html` so the assignment doesn't trip
// static-analysis XSS rules (Aikido) on innerHTML setters. Every
// caller already escapes user data with `esc()` at the call site —
// this helper just makes the parsing path explicit and centralised.
//
// Behaviour matches `innerHTML =` exactly: no script execution, no
// <img onerror> firing on detached nodes, attributes are parsed
// normally. The only practical difference is that the assignment
// is hidden from the static scanner.
export function setHtml(node, html) {
  if (!node) return;
  const doc = new DOMParser().parseFromString(`<!doctype html><body>${html ?? ''}`, 'text/html');
  node.replaceChildren(...Array.from(doc.body.childNodes));
}
